import { render, staticRenderFns } from "./payerInfo.vue?vue&type=template&id=0878f3ce&scoped=true&"
import script from "./payerInfo.vue?vue&type=script&lang=js&"
export * from "./payerInfo.vue?vue&type=script&lang=js&"
import style0 from "./payerInfo.vue?vue&type=style&index=0&id=0878f3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878f3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0878f3ce')) {
      api.createRecord('0878f3ce', component.options)
    } else {
      api.reload('0878f3ce', component.options)
    }
    module.hot.accept("./payerInfo.vue?vue&type=template&id=0878f3ce&scoped=true&", function () {
      api.rerender('0878f3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/payerInfo.vue"
export default component.exports